import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminApp } from '../models/admin-app';
import { AppMessage } from '../models/app-message';
import { MainApp } from '../models/main-app';
import { Member, MemberList, MemberStats } from '../models/member';
import { Source } from '../models/source';
import { ZbResponse } from '../models/zb-response';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class MainAppService extends BaseService {

  access_token = 'asf@#$43dasd#%$fdffdD#4565656'
  public isLoading = false;
  public selectedLangId :number = 0;

  public mainApp: MainApp
  public adminApp: AdminApp
  
  public user() : Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiUrl}/Admin/user`);
  }

  public getMainApp(selectedLangId) : Observable<ZbResponse<MainApp>> {
    this.selectedLangId = selectedLangId;
    return this.http.get<ZbResponse<MainApp>>(`${environment.apiUrl}/MainApp/${selectedLangId}`, {headers: new HttpHeaders({'access_token': this.access_token})});
  }

  public newMember(member: Member) : Observable<ZbResponse<boolean>> {
    return this.http.post<ZbResponse<boolean>>(`${environment.apiUrl}/MainApp`, member, {headers: new HttpHeaders({'access_token': this.access_token})});
  }
  
  public getMemberlist(dateFrom: Date, dateUntil: Date) : Observable<ZbResponse<MemberList[]>> {
    dateFrom.setHours(0,0,0);
    dateUntil.setHours(23,59,59);
    return this.http.get<ZbResponse<MemberList[]>>(`${environment.apiUrl}/Admin/MemberList/${dateFrom.toUTCString()}/${dateUntil.toUTCString()}`);
  }

  public getMemberTrash(dateFrom: Date, dateUntil: Date) : Observable<ZbResponse<MemberList[]>> {
    dateFrom.setHours(0,0,0);
    dateUntil.setHours(23,59,59);
    return this.http.get<ZbResponse<MemberList[]>>(`${environment.apiUrl}/Admin/MemberTrash/${dateFrom.toUTCString()}/${dateUntil.toUTCString()}`);
  }


  public getMemberStats(dateFrom: Date, dateUntil: Date, ageGroupsArray) : Observable<ZbResponse<MemberStats>> {
    dateFrom.setHours(0,0,0);
    dateUntil.setHours(23,59,59);
    return this.http.post<ZbResponse<MemberStats>>(`${environment.apiUrl}/Admin/MemberStats/${dateFrom.toUTCString()}/${dateUntil.toUTCString()}`, ageGroupsArray);
  }

  public getAppMessages() : Observable<ZbResponse<AppMessage[]>> {
    return this.http.get<ZbResponse<AppMessage[]>>(`${environment.apiUrl}/Admin/GetAppMessages`);
  }

  public getSources() : Observable<ZbResponse<Source[]>> {
    return this.http.get<ZbResponse<Source[]>>(`${environment.apiUrl}/Admin/GetSources`);
  }

  public getMember(memberId: number) : Observable<ZbResponse<MemberList>> {
    return this.http.get<ZbResponse<MemberList>>(`${environment.apiUrl}/Admin/Member/${memberId}`);
  }

  public updateAppMessage(appMessage: AppMessage) : Observable<ZbResponse<boolean>> {
    return this.http.post<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/UpdateAppMessage`, appMessage);
  }

  public postSource(source: Source) : Observable<ZbResponse<boolean>> {
    return this.http.post<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/PostSource`, source);
  }

  public deleteSource(source: Source) : Observable<ZbResponse<boolean>> {
    return this.http.delete<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/DeleteSource/${source.sourceId}`);
  }

  public deleteMember(memberId: number) : Observable<ZbResponse<boolean>> {
    return this.http.delete<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/Member/${memberId}`);
  }

  public getHardDeleteMembersCount(dateFrom: Date, dateUntil: Date) : Observable<ZbResponse<number>> {
    dateFrom.setHours(0,0,0);
    dateUntil.setHours(23,59,59);
    return this.http.get<ZbResponse<number>>(`${environment.apiUrl}/Admin/MemberHardDeleteCount/${dateFrom.toUTCString()}/${dateUntil.toUTCString()}`);
  }

  public hardDeleteMembers(dateFrom: Date, dateUntil: Date) : Observable<ZbResponse<number>> {
    dateFrom.setHours(0,0,0);
    dateUntil.setHours(23,59,59);
    return this.http.delete<ZbResponse<number>>(`${environment.apiUrl}/Admin/MemberHardDelete/${dateFrom.toUTCString()}/${dateUntil.toUTCString()}`);
  }

  public restoreMember(memberId: number) : Observable<ZbResponse<boolean>> {
    return this.http.put<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/MemberRestore/${memberId}`, null);
  }

  public getAdminApp() : Observable<ZbResponse<AdminApp>> {
    return this.http.get<ZbResponse<AdminApp>>(`${environment.apiUrl}/Admin/GetAdminApp`);
  }

  public removeAllMainAppData() : Observable<ZbResponse<boolean>> {
    return this.http.post<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/RemoveAllMainAppData`, null);
  }

  public saveMember(member: MemberList) : Observable<ZbResponse<boolean>> {
    return this.http.post<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/SaveMember`, member);
  }

  public sendMemberEmail(memberId: number,templateId: number) : Observable<ZbResponse<boolean>> {
    return this.http.post<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/SendMemberEmail/${memberId}/${templateId}`, null);
  }

  public setMvpPlayer(memberId: number, isMvpPlayer: boolean) : Observable<ZbResponse<boolean>> {
    return this.http.put<ZbResponse<boolean>>(`${environment.apiUrl}/Admin/MemberSetMvpPlayer/${memberId}/${isMvpPlayer}`, null);
  }
}
